export default "__VITE_ASSET__0qB7YFe$__"